import { render, staticRenderFns } from "./liberacao-detalhe.vue?vue&type=template&id=0031c32c&"
import script from "./liberacao-detalhe.vue?vue&type=script&lang=js&"
export * from "./liberacao-detalhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports